<template>
    <div>
        <cw-modal :id="store.modals.PRICING_TABLE_RAPPORTEN" :title="translate('bedrijfsrapporten')" size="md">
            <div class="grid grid-cols-1 gap-10 mt-6">
                <div class="flex flex-col gap-5">
                    <ul class="list">
                        <li>{{translate('modal_rapporten_usp_1')}}</li>
                        <li>{{translate('modal_rapporten_usp_2')}}</li>
                        <li>{{translate('modal_rapporten_usp_3')}}</li>
                    </ul>
                </div>
            </div>
            <div class="grid grid-cols-1 gap-10 mt-6">
                <div>
                    <img src="/images-new/pricing/features/report-premium.liza.png" alt="Premium" class="border border-grey-300 rounded-lg overflow-clip"/>
                </div>
            </div>
            <div class="grid grid-cols-1 gap-10 mt-6">
                <div>
                    <a :href="'/'+language+'/sample/report/premium'" target="_blank" class="btn btn-sm btn-ghost">{{translate('sample_report')}}</a>
                </div>
            </div>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_BEDRIJFSLEIDING" :title="translate('bedrijfsleiding')" size="md">
           <div class="max-h-[70vh] overflow-y-auto">
               <div class="grid grid-cols-1 gap-10 mt-6">
                   <div class="flex flex-col gap-5">
                       <ul class="list">
                           <li>{{translate('modal_management_usp_1')}}</li>
                           <li>{{translate('modal_management_usp_2')}}</li>
                           <li>{{translate('modal_management_usp_3')}}</li>
                           <li>{{translate('modal_management_usp_4')}}</li>
                       </ul>
                   </div>
               </div>
               <div class="grid grid-cols-1 gap-10 mt-6">
                   <div class="space-y-2">
                       <img src="/images-new/pricing/features/mandates_basic.liza.png" alt="Premium" class="border border-grey-300 rounded-lg overflow-clip"/>
                       <img src="/images-new/pricing/features/mandates_premium.liza.png" alt="Premium" class="border border-grey-300 rounded-lg overflow-clip"/>
                   </div>
               </div>
           </div>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_BEDRIJFSINFORMATIE" :title="translate('bedrijfsinformatie')" >
            <ul class="list">
                <li>{{translate('modal_bedrijfsinformatie_usp_1')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_2')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_3')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_4')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_5')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_8')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_9')}}</li>
            </ul>
        </cw-modal>

        <cw-modal :id="store.modals.PRICING_TABLE_BETALINGSERVARING" :title="translate('betalingservaring')">
            <div>
                <p>
                    {{translate('modal_betalingservaring_usp')}}
                </p>
                <img :src="'/images-new/tools/features/betalingservaring.' + language + '.png'" alt="Standard" class="mt-6 border border-grey-300 rounded-lg overflow-clip"/>
            </div>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_TIMELINE" :title="translate('tijdslijn')">
            <div>
                <img src="/images-new/tools/timeline-liza.png" class="w-full mt-8" :alt="translate('tijdslijn')" />
            </div>
        </cw-modal>
        <div class="[&>div]:grid [&>div]:grid-cols-2 
        [&>div>div]:py-3 
        [&>div>div]:px-6 
        [&>div>div]:flex 
        [&>div>div]:items-center 
        [&>div>div]:border-b 
        [&>div>div]:border-grey-200 
        [&>div]:hover:[&>div]:bg-grey-100 
        [&>div>div:nth-child(2)]:border-x max-w-3xl mx-auto">
            <div class="sticky top-0">
                <div class="!bg-white !block"></div>
                <div class="rounded-t-xl !block border-t !bg-white relative">
                    <div class="size-14  -ml-2 box-content flex items-center justify-center">
                        <img src="/images-new/pricing/premium.svg" alt="premium" />
                    </div>
                    <div class="text-lg font-semibold ">Liza Premium</div>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('aantal_gebruikers')}}</div>
                <div>
                    <select v-model="form.users[PackageType.LIZAPREMIUM]">
                        <option v-for="o in users" :value="o">{{o.amount}}</option>
                    </select>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('opzoekingen_per_week')}}</div>
                <div>
                    <select v-model="form.webhits[PackageType.LIZAPREMIUM]">
                        <option v-for="o in webhitsPremium" :value="o">{{o.amount}}</option>
                    </select>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('bedrijven_in_alerts')}}</div>
                <div>
                     <select v-model="form.alerts[PackageType.LIZAPREMIUM]">
                         <option v-for="o in alertsPremium" :value="o">{{o.amount}}</option>
                     </select>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('bedrijven_in_alerts_plus')}}</div>
                <div>
                    <select v-model="form.alerts_plus[PackageType.LIZAPREMIUM]">
                        <option v-for="o in alertsPlus" :value="o">{{o.amount}}</option>
                    </select>
                </div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('screening_klantenbestand')}}</div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
            </div>

            <div>
                <div>
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_RAPPORTEN)">{{translate('bedrijfsrapporten')}}</a>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
            </div>
            
            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_BEDRIJFSINFORMATIE)">{{translate('bedrijfsinformatie')}}</a>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
            </div>
            
            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_BEDRIJFSLEIDING)">{{translate('bedrijsleiding')}}</a>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('zoeken_op_bedrijf')}}</div>
                <div><i class="fas fa-check text-primary-400"></i> </div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('zoeken_op_adres')}}</div>
                <div><i class="fas fa-check text-primary-400"></i> </div>
            </div>
            
            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_TIMELINE)">{{translate('tijdslijn')}}</a>
                </div>
                <div><i class="fas fa-check text-primary-400"></i> </div>
            </div>

            <div>
                <div class="font-medium">{{translate('internationale_rapporten')}}</div>
                <div>
                    <select v-model="form.international_reports[PackageType.LIZAPREMIUM]">
                        <option v-for="o in internationalReports" :value="o">{{o.amount}}</option>
                    </select>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('prospectie_en_eigen_data_verrijken')}}</div>
                <div>
                    <select v-model="form.dm_credits[PackageType.LIZAPREMIUM]">
                        <option v-for="o in dmCredits" :value="o">{{o.amount}}</option>
                    </select>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('add_ayce_be')}}</div>
                <div>
                    <input type="checkbox" v-model="includeBe">
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('add_ayce_lu')}}</div>
                <div>
                    <input type="checkbox" v-model="includeLu">
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('add_ayce_fr')}}</div>
                <div>
                    <input type="checkbox" v-model="includeFr">
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('integraties')}}</div>
                <div>{{translate('custom_tbd')}}</div>
            </div>
    
            <div>
                <div class="!pt-12 !border-b-0 text-lg font-semibold sticky top-14 bg-white">{{translate('totaalprijs')}}</div>
                <div class="!pt-12 !border-b-0 font-semibold text-lg">
                    € {{getPackagePrice(PackageType.LIZAPREMIUM).formatThousandSeparator()}}
                    <span class="text-sm text-grey-800 font-normal ml-2">{{translate('per_jaar')}}</span>
                </div>
            </div>
        </div>
        <div class="mt-12 text-center">
            <span class="alert info">
                {{translate('excl_vat_message')}}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useStore as useCheckoutStore} from "../../store";
import {Language} from "../../../../types/dto/Language";
import {Package, PackageType} from "../../types";

interface PricingOption {
    amount: number;
    price: number;
}

enum LijnNaam {
    USERS = "users",
    WEBHITS = "webhits",
    ALERTS = "alerts",
    ALERTS_PLUS = "alerts_plus",
    MOBILE_APP = "mobile_app",
    INTERNATIONAL_REPORTS = "international_reports",
    ALERTS_INTERNATIONAL = "alerts_international",
    PEP_CHECKS = "pep_checks",
    DM_CREDITS = "dm_credits",
    INCLUDE_NL = "include_nl",
}

type Config = Record<LijnNaam, {[PackageType.LIZAPREMIUM]: PricingOption}>;

export default defineComponent({
    name: "sales-pricing-table-liza",
    props: {
        language: String as () => Language
    },
    data() {
        const users = window.cw.pricing.users as PricingOption[];
        const webhitsPremium = window.cw.pricing.webhitsPremium as PricingOption[];
        const alertsPremium = window.cw.pricing.alertsPremium as PricingOption[];
        const alertsPlus = window.cw.pricing.alertsPlus as PricingOption[];
        const internationalReports = window.cw.pricing.internationalReports as PricingOption[];
        const dmCredits = window.cw.pricing.dmCredits as PricingOption[];
        
        return {
            checkoutStore: useCheckoutStore(),
            includeBe: false,
            includeLu: false,
            includeFr: false,
            PackageType,
            form: {
                [LijnNaam.USERS]: {
                    [PackageType.LIZAPREMIUM]: users[0]
                },
                [LijnNaam.ALERTS]: {
                    [PackageType.LIZAPREMIUM]: alertsPremium[0]
                },
                [LijnNaam.WEBHITS]: {
                    [PackageType.LIZAPREMIUM]: webhitsPremium[0]
                },
                [LijnNaam.ALERTS_PLUS]: {
                    [PackageType.LIZAPREMIUM]: alertsPlus[0]
                },
                [LijnNaam.INTERNATIONAL_REPORTS]: {
                    [PackageType.LIZAPREMIUM]: internationalReports[0]
                },
                [LijnNaam.DM_CREDITS]: {
                    [PackageType.LIZAPREMIUM]: dmCredits[0]
                }
            } as Config,
            users,
            webhitsPremium,
            alertsPremium,
            alertsPlus,
            internationalReports,
            dmCredits
        }
    },
    methods: {
      getPackagePrice(pack: PackageType.LIZAPREMIUM): number {
          const basePrice = this.checkoutStore.premiumPrice;
          const extraCountryPrice = this.checkoutStore.extraCountryPrice;
          const featurePrice = Object.values(this.form).reduce((price, config) => {
              return price + config[pack].price;
          }, 0);
          const ayceBePrice = (this.includeBe) ? extraCountryPrice : 0;
          const ayceLuPrice = (this.includeLu) ? extraCountryPrice : 0;
          const ayceFrPrice = (this.includeFr) ? extraCountryPrice : 0;
          
          return basePrice + featurePrice + ayceBePrice + ayceLuPrice + ayceFrPrice;
      }
    },
});
</script>